import { render, staticRenderFns } from "./ManterTipoCreditoAssunto.vue?vue&type=template&id=6c24cf68&scoped=true&"
import script from "./ManterTipoCreditoAssunto.vue?vue&type=script&lang=js&"
export * from "./ManterTipoCreditoAssunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24cf68",
  null
  
)

export default component.exports